import React from "react";
import "./depositHistory.css";

// IF todo is an empty string we do not want it displayed
// todo is empty by default to prevent passing empty children in react

const DepositHistory = ({ todo, words }) => {
  console.log("words", words)
  return (
    <>
      {todo["word"] === "" ? (
        ""
      ) : (
        <ul className="todo-ul">
          <li className="todo-li">{todo.text}</li>{" "}
        </ul>
      )}
    </>
  );
};

export default DepositHistory;
